<script setup lang="ts">
const emit = defineEmits(["opened"]);

function openModal() {
  globalEmit("app::openTweetEditor", "feedback");
  emit("opened");
}
</script>

<template>
  <button class="btn btn--feedback" @click="openModal">Share Feedback</button>
</template>
